
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Uniform = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>School Uniform</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Academics</li>
                    <li>|</li>
                    <li>School Uniform</li>
                </ul>
            </div>
            <div className="inner_page uniform_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3 className="heading">School Uniform</h3>
                        </div>
                        <div className="col-lg-6">
                            <div className="uniform_blk">
                                <h3 className="sub-heading"> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/children.png" /> Summer</h3>
                              <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/uniform1.jpg" alt="st francis school, amritsar" /></LazyLoad>
                                <p><b>Boys:</b> White Shirt, Grey Pant, Black Shoes, White Socks with Maroon Strips, School Belt & Tie</p>                               
                                <p><b>Girls:</b>White Shirt, Check Skirt/tunic, Black Shoes, White Socks with Maroon Strips, School Belt & Tie</p>
                            </div>                           
                        </div> 
                        <div className="col-lg-6">                           
                            <div className="uniform_blk">
                                <h3 className="sub-heading"><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/children.png" /> Winter</h3>
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/uniform3.jpg" alt="st francis school, amritsar" /></LazyLoad>
                                <p><b>Boys:</b> White Shirt (Full Sleeves), Grey Pants, Black Shoes, Grey Socks with Maroon Strips, School Belt and Tie, V-Necked Grey Pull over with two Maroon strips on the neck, Maroon Coat, Maroon Scarf (Sikh)</p>                               
                                <p><b>Girls:</b> White Shirt (Full Sleeves), Check Skirt/tunic, Black Shoes, Grey Socks with Maroon strips, School Belt and Tie, V-Necked Grey Pull over with two maroon strips on the neck, Maroon Coat, Maroon Scarf.</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <h3 className="heading">P T Uniform</h3>
                        </div>
                        <div className="col-lg-6">
                            <div className="uniform_blk">
                                <h3 className="sub-heading"><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/boy.png" />  Boys (Summer)</h3>
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/uniform5.jpg" alt="st francis school, amritsar" /></LazyLoad>
                                <p>White Shorts/Pants, House wise coloured T-Shirts, White Socks with Maroon strips, white Canvas Shoes, White Scarf (Sikh boys), Maroon Coat (in Winter)</p>                               
                                
                            </div>                           
                        </div> 
                        <div className="col-lg-6">                           
                            <div className="uniform_blk">
                                <h3 className="sub-heading"><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/girl.png" /> Girls (Summer)</h3>
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/uniform6.jpg" alt="st francis school, amritsar" /></LazyLoad>
                                <p>White Skirts, House wise coloured Track Suit, White Socks with Maroon strips, White Canvas shoes.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">                           
                            <div className="uniform_blk">
                                <h3 className="sub-heading"><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/boy.png" /> Boys (Winter)</h3>
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/uniform7.jpg" alt="st francis school, amritsar" /></LazyLoad>
                                <p> White Pants, White Shirts (Full Sleeves), V-necked Grey Sweater with two maroon strips on the neck, Maroon Coat, Maroon Scarf/Cap (Sikhs).</p>
                            </div>
                        </div>
                        <div className="col-lg-6">                           
                            <div className="uniform_blk">
                                <h3 className="sub-heading"><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/girl.png" /> Girls (Winter)</h3>
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/uniform8.jpg" alt="st francis school, amritsar" /></LazyLoad>
                                <p>White Skirts, White Shirts (Full Sleeves), V – necked Grey Sweater with two maroon strips on the neck, maroon Coat, Maroon Scarf/Cap (Sikhs).</p>
                            </div>
                        </div>
                        
                        <div className="col-lg-12 mt-4"> <p><b>Note: </b>wearing id card is compulsory</p></div>
                        <div className="col-lg-6">                           
                            <div className="uniform_blk">
                                <h3 className="sub-heading">
                                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/girl.png" /></LazyLoad> Instructions for Girls</h3> 
                                <ul className="list-view">
                                <li>With long hair should make two plaits with maroon ribbons in winter & in Summer.</li>
                                <li>Girls with shorts hair should comb them straight and put on red band in Winter Summer.</li>
                                <li>Jewelry, nail polish, decorative hair pins and band are not allowed.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">                           
                            <div className="uniform_blk">
                                <h3 className="sub-heading"><LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/boy.png" /> </LazyLoad>Instructions for Boys</h3> 
                                <ul className="list-view">
                                    <li>Spiky/Long Hairstyle is not allowed</li>
                                    <li>Any accessories (Bracelet with sharp edges Chain and Ring) are not allowed</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Uniform
